import styled from 'styled-components'

export const Container = styled.div`
  background: #fff;
`

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 16px;
  border-bottom: 2px solid #f0f0f0;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }
`

export const DateInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const Weekday = styled.div`
  font-size: 14px;
  color: #8c8c8c;
  text-transform: uppercase;
  font-weight: 500;
  letter-spacing: 0.5px;
`

export const Date = styled.div`
  display: flex;
  align-items: baseline;
  gap: 12px;
`

export const Day = styled.span`
  font-size: 48px;
  font-weight: 700;
  color: #262626;
  line-height: 1;

  @media (max-width: 768px) {
    font-size: 36px;
  }
`

export const Month = styled.span`
  font-size: 20px;
  color: #595959;
  font-weight: 500;

  @media (max-width: 768px) {
    font-size: 16px;
  }
`

export const Stats = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
  }
`

export const Content = styled.div`
  min-height: 500px;

  @media (max-width: 768px) {
    min-height: 400px;
  }
`

export const Timetable = styled.div`
  padding: 16px 0;
`

export const Tasks = styled.div`
  padding: 16px 0;
  min-height: 460px;

  @media (max-width: 768px) {
    min-height: 360px;
  }
`

export const TasksList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-height: calc(100vh - 250px);
  overflow-y: auto;
  padding-right: 8px;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f0f0f0;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: #bfbfbf;
    border-radius: 3px;
    
    &:hover {
      background: #8c8c8c;
    }
  }

  @media (max-width: 768px) {
    max-height: calc(100vh - 300px);
  }
`

export const NoTasks = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 460px;
  gap: 16px;

  @media (max-width: 768px) {
    min-height: 360px;
  }
`

export const NoTasksIcon = styled.div`
  font-size: 64px;
  opacity: 0.3;
`

export const NoTasksText = styled.div`
  font-size: 16px;
  color: #bfbfbf;
  font-weight: 500;
  margin-top: 20px;
`


